export default "__VITE_ASSET__DO6WMrQE__"